import React, { useState } from "react";
import Navbar from "../../components/Navbar/Index";
import { useOutletContext } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfo,faUserGroup } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";

function Form() {
  const [sidebarToggle] = useOutletContext();
  const [loading, setLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [groupName, setGroupName] = useState('');
  const [groupDescription, setGroupDescription] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true)
    try {
      const response = await axios.post(
        'https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/groups/create',
        { groupName, groupDescription },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.idToken}`, // Replace with your actual token
          },
        }
      );
      setSuccessMessage('Group created successfully');
      alert("Group created successfully");
      setGroupName('');
      setGroupDescription('');
      setLoading(false)
    } catch (error) {
      setError('Error creating group');
      setLoading(false)
      alert(error)
    }
  };

  return (
    <>
      <main className="h-full">
        <Navbar toggle={sidebarToggle} />

        {/* Main Content */}
        <div className="mainCard">
          <div className="border w-full border-gray-200 bg-white py-4 px-6 rounded-md">
            <form onSubmit={handleSubmit}>
              {/* With Icon */}
              <div className="mt-6 relative">
                <label
                  htmlFor="email"
                  className="text-sm text-gray-600"
                >
                  Group Name
                </label>

                <div className="inline-flex items-center justify-center absolute left-0 top-[0.85rem] h-full w-10 text-gray-400">
                  <FontAwesomeIcon icon={faUserGroup} />
                </div>
                <input
                  type="text"
                  id="groupName"
                  value={groupName}
                  onChange={(e) => setGroupName(e.target.value)}
                  required
                  className="text-sm placeholder-gray-500 pl-10 px-4 rounded-lg border border-gray-200 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400 mt-1"
                  placeholder="211"
                />
              </div>
              <div className="mt-6 relative">
                <label
                  htmlFor="email"
                  className="text-sm text-gray-600"
                >
                  Description
                </label>

                <div className="inline-flex items-center justify-center absolute left-0 top-[0.85rem] h-full w-10 text-gray-400">
                  <FontAwesomeIcon icon={faInfo} />
                </div>
                <input
                  type="text"
                  id="groupDescription"
                  value={groupDescription}
                  onChange={(e) => setGroupDescription(e.target.value)}
                  required
                  className="text-sm placeholder-gray-500 pl-10 px-4 rounded-lg border border-gray-200 w-full md:py-2 py-3 focus:outline-none focus:border-emerald-400 mt-1"
                  placeholder="Manali Trip"
                />
              </div>

              <div className="mt-6 flex flex-row gap-4">
                {loading ? (
                    <div
                      className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                      role="status">
                      <span
                        className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                      >Loading...</span>
                    </div>
                  
                ) :
                  <button className="bg-emerald-600 text-gray-100 px-3 py-2 rounded-lg shadow-lg text-sm" type="submit">
                    Add
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      </main>
    </>
  );
}

export default Form;
